import React, { useEffect } from 'react'
import DataTable from '../../datatable'
import { useState } from 'react'
import { PAGINATION_DEFAULT } from '../../../utils/constants'
import {
  useDeleteAssignPerformance,
  useDeletePerformance,
  useGetSupervisorEvaluations,
} from '../../../redux/human-resources/hook/performance'
import ViewPerformance from '../../modal/hr-section/performance/ViewPerformance'

const SupervisorEvaluations = () => {
  useEffect(() => {}, [])
  const [tableType, setTableType] = useState('table')
  const [viewPerformance, setViewPerformance] = useState(false)
  const [performanceData, setPerformanceData] = useState(null)
  const [assessmentData, setAssessmentData] = useState()

  const switchFunction = () => {
    if (tableType === 'table') {
      setTableType('performance')
    } else {
      setTableType('table')
    }
  }

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })

  const { data: performances } = useGetSupervisorEvaluations(
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  )

  const { mutateAsync: deleteAssignEvaluation } = useDeleteAssignPerformance()

  const tableConfig = {
    headers: [
      'Date Created',
      'Employee Name',
      'Mobile',
      'Period Covered',
      'Source',
    ],
    keys: ['created', 'employeeName', 'mobile', 'period', 'source'],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Period Covered',
        key: 'period',
      },
    },
  }
  const actionConfig = [
    {
      name: 'View',
      color: 'green',
      action: (id) => {
        let index = performances.data.findIndex((item) => item.id === id)
        setAssessmentData(performances.data?.[index])
        setViewPerformance(true)
      },
    },
    {
      name: 'Delete',
      color: 'red',
      action: (id) => {
        let index = performances.data.findIndex((item) => item.id === id)
        deleteAssignEvaluation(performances.data[index].id)
      },
    },
  ]

  return (
    <div className='flex flex-col bg-white rounded -mt-2'>
      {viewPerformance ? (
        <ViewPerformance
          isOpen={viewPerformance}
          closeModal={() => setViewPerformance(false)}
          assessmentData={assessmentData}
          data={assessmentData?.results}
        />
      ) : null}
      <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
        <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full'>
          Supervisor Evaluations
        </div>
      </div>
      <hr className='divider mt-2 mb-1' />
      <DataTable
        data={performances}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        tableType={tableType}
        switchFunction={switchFunction}
        layoutSwitch={true}
        searchData={true}
      />
    </div>
  )
}

export default SupervisorEvaluations
